import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Pricing.css';

export const Pricing: React.FC = () => {
  const pricingData = [
    { unit: 'Unit 1', rent: '£373 / month', area: '10.00 SQM' },
    { unit: 'Unit 2', rent: '£327 / month', area: '8.49 SQM' },
    { unit: 'Unit 3', rent: '£327 / month', area: '8.53 SQM' },
    { unit: 'Units 4 & 5', rent: '£658 / month', area: '18.69 SQM' },
    { unit: 'Unit 6', rent: '£299 / month', area: '6.50 SQM' },
    { unit: 'Units 7 & 8', rent: '£475 / month', area: '14.04 SQM' },
  ];

  const facilitiesData = [
    { facility: 'Kitchen', area: '17.68 SQM' },
    { facility: 'WC', area: '1.95 SQM' },
    { facility: 'Shower', area: '1.87 SQM' },
  ];

  return (
    <div className="pricing-container">
      <Helmet>
        <title>Pricing & Availability | Small Offices to Let in Bagshot</title>
        <meta name="description" content="View monthly rental prices and floor areas for our small office units and communal facilities to let in the centre of Bagshot." />
        <link rel="canonical" href="https://www.bagshot-offices.co.uk/pricing" />
      </Helmet>
      <h1 className="pricing-title">Our Prices</h1>
      <p className="pricing-intro">
        Competitive monthly rates for office units right in the centre of Bagshot, plus communal facility specifications.
      </p>

      <div className="table-responsive">
        <table className="pricing-table">
          <thead>
            <tr>
              <th>Unit</th>
              <th>Monthly Rent</th>
              <th>Area</th>
            </tr>
          </thead>
          <tbody>
            {pricingData.map((row, index) => (
              <tr key={index}>
                <td>{row.unit}</td>
                <td>{row.rent}</td>
                <td>{row.area}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="pricing-notes">
        Prices include: internet, electricity, heating, water, rates & weekly cleaning
      </p>

      <div className="facilities-section">
        <h2>Communal Facilities Floor Areas</h2>
        <div className="table-responsive">
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Facility</th>
                <th>Area</th>
              </tr>
            </thead>
            <tbody>
              {facilitiesData.map((row, index) => (
                <tr key={index}>
                  <td>{row.facility}</td>
                  <td>{row.area}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
